module.exports = __webpack_public_path__ + "img/info-icon.cff95f15.svg";